// src/services/settingsServices.js
import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/settings`;

// Lis le token au moment de l'appel (évite les tokens périmés)
const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/* =========================
   GET (privé) — paramètres complets
   ========================= */
export const getSettings = async () => {
  try {
    const { data } = await axios.get(`${apiUrl}/getSettings`, {
      headers: authHeaders(),
    });
    return data; // ex: { id, primary_color, primary_color2, ... }
  } catch (e) {
    if (e?.response?.status === 401 || e?.response?.status === 403) return null;
    console.error("Erreur getSettings:", e);
    return null;
  }
};

/* =========================
   GET (public) — uniquement les couleurs
   ========================= */
export const getPublicColors = async () => {
  try {
    const { data } = await axios.get(`${apiUrl}/public/colors`);
    return data;
  } catch (e) {
    console.error("Erreur getPublicColors:", e);
    return null;
  }
};

/* =========================
   PUT (privé) — mise à jour générique (tous champs)
   ========================= */
export const updateSettings = async (settings) => {
  try {
    const { data } = await axios.put(`${apiUrl}/updateSettings`, settings, {
      headers: { "Content-Type": "application/json", ...authHeaders() },
    });
    return data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour des paramètres:", error);
    return null;
  }
};

/* =========================
   PUT (privé) — mise à jour ciblée des couleurs
   ========================= */
export const updateSettingsColors = async ({
  primary_color,
  primary_color2,
  button_primary_color,
  button_primary_color2,
}) => {
  try {
    const { data } = await axios.put(
      `${apiUrl}/colors`,
      { primary_color, primary_color2, button_primary_color, button_primary_color2 },
      { headers: { "Content-Type": "application/json", ...authHeaders() } }
    );
    return data; // { ok: true, ... }
  } catch (e) {
    console.error("Erreur updateSettingsColors:", e);
    return null;
  }
};

/* =========================================================
   🆕 ALERTES / BANDEAU (Home + Admin)
   ========================================================= */

/* =========================
   GET (public) — bandeau d'alerte pour la page Accueil
   =========================
   Retour attendu:
   {
     alert: {
       is_active: boolean,
       type: "info"|"warning"|"danger"|"success",
       title: string|null,
       message: string|null,
       link_label: string|null,
       link_url: string|null,
       start_at: string|null,
       end_at: string|null
     }
   }
*/
export const getPublicAlert = async () => {
  try {
    const { data } = await axios.get(`${apiUrl}/public/alert`);
    return data;
  } catch (e) {
    console.error("Erreur getPublicAlert:", e);
    return null;
  }
};

/* =========================
   PUT (privé) — mise à jour de la bannière d'alerte (admin)
   =========================
   payload possible:
   {
     alert_is_active?: boolean,
     alert_type?: "info"|"warning"|"danger"|"success",
     alert_title?: string|null,
     alert_message?: string|null,
     alert_link_label?: string|null,
     alert_link_url?: string|null,
     alert_start_at?: string|null, // ISO date ou "" pour null
     alert_end_at?: string|null
   }
*/
export const updateSettingsAlert = async (payload) => {
  try {
    const { data } = await axios.put(`${apiUrl}/alert`, payload, {
      headers: { "Content-Type": "application/json", ...authHeaders() },
    });
    return data; // { ok: true, alert: {...} }
  } catch (e) {
    console.error("Erreur updateSettingsAlert:", e);
    return null;
  }
};

/* =========================
   POST (privé) — désactivation rapide de la bannière (admin)
   ========================= */
export const disableSettingsAlert = async () => {
  try {
    const { data } = await axios.post(
      `${apiUrl}/alert/disable`,
      {},
      { headers: authHeaders() }
    );
    return data; // { ok: true, message: ... }
  } catch (e) {
    console.error("Erreur disableSettingsAlert:", e);
    return null;
  }
};
